/* ==========================================================================
   oddit-footer-main — Mobile accordion toggles + country/region selector
   ========================================================================== */

(function () {
  var SECTION_SELECTOR = '.oddit-footer-main';
  var openCountrySelectors = [];

  function initSection(section) {
    var toggles = section.querySelectorAll('.oddit-footer-main__column-toggle');

    for (var i = 0; i < toggles.length; i++) {
      toggles[i].addEventListener('click', handleToggle);
    }

    var countrySelectors = section.querySelectorAll('[data-oddit-country]');
    for (var j = 0; j < countrySelectors.length; j++) {
      initCountrySelector(countrySelectors[j]);
    }
  }

  function handleToggle(e) {
    var btn = e.currentTarget;
    var panelId = btn.getAttribute('aria-controls');
    var panel = document.getElementById(panelId);
    if (!panel) return;

    var isOpen = panel.classList.contains('is-open');

    if (isOpen) {
      panel.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    } else {
      panel.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    }
  }

  function initCountrySelector(root) {
    var toggle = root.querySelector('[data-oddit-country-toggle]');
    var list = root.querySelector('[data-oddit-country-list]');
    var input = root.querySelector('[data-oddit-country-input]');
    var options = root.querySelectorAll('[data-oddit-country-option]');
    var form = root.closest('form');
    if (!toggle || !list || !input || !form) return;

    function open() {
      list.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      root.classList.add('is-open');
      var current = list.querySelector('.is-current') || options[0];
      if (current) current.focus();
      if (openCountrySelectors.indexOf(root) === -1) openCountrySelectors.push(root);
    }

    function close() {
      list.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      root.classList.remove('is-open');
      var idx = openCountrySelectors.indexOf(root);
      if (idx !== -1) openCountrySelectors.splice(idx, 1);
    }

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      if (toggle.getAttribute('aria-expanded') === 'true') {
        close();
      } else {
        // Close any other open selectors first
        openCountrySelectors.slice().forEach(function (other) {
          if (other !== root) other.dispatchEvent(new CustomEvent('oddit:country:close'));
        });
        open();
      }
    });

    root.addEventListener('oddit:country:close', close);

    for (var i = 0; i < options.length; i++) {
      var option = options[i];
      option.setAttribute('tabindex', '-1');
      option.addEventListener('click', function () {
        var value = this.getAttribute('data-value');
        if (!value) return;
        input.value = value;
        form.submit();
      });
      option.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });
    }
  }

  document.addEventListener('click', function (e) {
    openCountrySelectors.slice().forEach(function (root) {
      if (!root.contains(e.target)) {
        root.dispatchEvent(new CustomEvent('oddit:country:close'));
      }
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    openCountrySelectors.slice().forEach(function (root) {
      var toggle = root.querySelector('[data-oddit-country-toggle]');
      root.dispatchEvent(new CustomEvent('oddit:country:close'));
      if (toggle) toggle.focus();
    });
  });

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();